export default __webpack_public_path__ + "static/media/enterprise.icon.56c88b71.svg";